import {Link as RouterLink, useMatch} from "react-router-dom";
import {ListItem, ListItemButton, ListItemIcon, ListItemText} from "@mui/material";

export interface SelectableListItemProps {
    to: string;
    matchPath: string;
    icon: React.ReactElement;
    text: string;
    isDisabled?: boolean;
    dataTest?: string;
}

export default function SelectableListItem({
    to, // Defines the target path
    matchPath, // Defines the match path, that controls the highlight state of the list item
    icon,
    text,
    isDisabled,
    dataTest = "selectableListItem",
}: SelectableListItemProps) {
    const match = useMatch(matchPath);
    return (
        <ListItem disablePadding data-test={dataTest}>
            <ListItemButton selected={match != null} disabled={isDisabled} component={RouterLink} to={to}>
                <ListItemIcon>{icon}</ListItemIcon>
                <ListItemText primary={text} />
            </ListItemButton>
        </ListItem>
    );
}
